module.exports = __webpack_public_path__ + "img/1920x400-page-banner.fba47b2d.jpg";